import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const externalSkusFilterConfig = {
    key: 'externalSkus',
    label: 'External SKU',
    type: FilterType.NUMBER,
    multi: true,
    deletable: true,
    placeholder: 'Enter external SKU...',
};

export const nameFilterConfig = {
    key: 'name',
    label: 'Name',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter name...',
};

export const brandFilterConfig = {
    key: 'brand',
    label: 'Brand',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter brand...',
};

export const ingredientsFilterConfig = {
    key: 'ingredients',
    label: 'Ingredients',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter ingredients...',
};

export const allergensFilterConfig = {
    key: 'allergens',
    label: 'Allergens',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter allergens...',
};

export const l1TaxonomyFilterConfig = {
    key: 'l1Taxonomies',
    label: 'L1 Taxonomy',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter L1 taxonomy...',
};

export const l2TaxonomyFilterConfig = {
    key: 'l2Taxonomies',
    label: 'L2 Taxonomy',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter L2 taxonomy...',
};

export const l3TaxonomyFilterConfig = {
    key: 'l3Taxonomies',
    label: 'L3 Taxonomy',
    type: FilterType.TEXT,
    deletable: true,
    placeholder: 'Enter L3 taxonomy...',
};

export const PartnerCatalogFilterConfigArray = [
    externalSkusFilterConfig,
    nameFilterConfig,
    brandFilterConfig,
    ingredientsFilterConfig,
    allergensFilterConfig,
    l1TaxonomyFilterConfig,
    l2TaxonomyFilterConfig,
    l3TaxonomyFilterConfig,
];

const ARRAY_FILTER_KEYS = ['name', 'brand', 'ingredients', 'allergens', 'l1Taxonomies', 'l2Taxonomies', 'l3Taxonomies'];

/**
 * @param {unknown} value
 * @returns {string[]}
 */
function toStringList(value) {
    if (Array.isArray(value)) {
        return value.map((part) => String(part ?? '').trim()).filter(Boolean);
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed ? [trimmed] : [];
    }
    return [];
}

/**
 * Maps EntityDropDownFilterContainer values to catalog API query params.
 * Multi-value filters are kept as arrays and sent as repeated `key[]=` params.
 *
 * @param {Object} [uiFilters={}]
 * @returns {{
 *   externalSkus?: number[],
 *   name?: string[],
 *   brand?: string[],
 *   ingredients?: string[],
 *   allergens?: string[],
 *   l1Taxonomies?: string[],
 *   l2Taxonomies?: string[],
 *   l3Taxonomies?: string[],
 * }}
 */
export function toCatalogApiFilters(uiFilters = {}) {
    const result = {};

    if (Array.isArray(uiFilters.externalSkus)) {
        const externalSkus = uiFilters.externalSkus
            .map((sku) => (typeof sku === 'string' ? Number.parseInt(sku, 10) : Number(sku)))
            .filter((sku) => Number.isInteger(sku) && sku > 0);
        if (externalSkus.length > 0) {
            result.externalSkus = externalSkus;
        }
    }

    ARRAY_FILTER_KEYS.forEach((key) => {
        const values = toStringList(uiFilters[key]);
        if (values.length > 0) {
            result[key] = values;
        }
    });

    return result;
}
